// Stats shown in the Placement section.
const placeStats = [
  { value: "1:1", label: "Unlimited career counselling sessions" },
  { value: "Pan-India", label: "MoUs with government & private organisations" },
  { value: "In-house HR", label: "Interviews scheduled by the IPDI HR team" },
];

function Outcomes() {
  return (
    <section className="place-sec">
      <style>{`
        .place-sec {
          background: #1A3828;
          color: #fff;
          padding: 5rem 0;
        }
        .place-sec .wrap {
          max-width: 1320px;
          margin: 0 auto;
          padding: 0 2.5rem;
        }
        .place-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 3rem;
          align-items: center;
        }

        .place-eyebrow {
          display: flex;
          align-items: center;
          gap: 0.7rem;
          margin-bottom: 1rem;
        }
        .place-eyebrow-dash {
          width: 28px;
          height: 1px;
          background: var(--terra-lt);
        }
        .place-eyebrow-text {
          font-family: var(--mono);
          font-size: 0.7rem;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: var(--terra-lt);
        }
        .place-title {
          font-family: var(--serif);
          font-weight: 400;
          font-size: clamp(2rem, 3.4vw, 2.8rem);
          line-height: 1.15;
          color: #fff;
          margin: 0 0 1.1rem;
        }
        .place-title em {
          font-style: italic;
          color: #D4723E;
        }
        .place-sub {
          font-size: 0.95rem;
          font-weight: 300;
          line-height: 1.8;
          color: rgba(255, 255, 255, 0.65);
          max-width: 46ch;
        }
        .place-btn {
          display: inline-flex;
          align-items: center;
          gap: 0.55rem;
          margin-top: 1.6rem;
          background: transparent;
          color: #fff;
          border: 1px solid rgba(255, 255, 255, 0.34);
          font-size: 0.74rem;
          font-weight: 600;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          padding: 0.9rem 1.6rem;
          transition: background 0.25s, color 0.25s;
        }
        .place-btn:hover {
          background: #fff;
          color: #1A3828;
        }

        .place-stats {
          display: flex;
          flex-direction: column;
        }
        .place-stat {
          border-left: 2px solid var(--terra-lt);
          padding-left: 1.2rem;
          margin-bottom: 1.6rem;
        }
        .place-stat:last-child {
          margin-bottom: 0;
        }
        .place-stat b {
          font-family: var(--serif);
          font-size: 2.4rem;
          color: #fff;
          font-weight: 500;
          display: block;
          line-height: 1;
        }
        .place-stat span {
          font-size: 0.8rem;
          color: rgba(255, 255, 255, 0.6);
          font-weight: 300;
        }

        @media (max-width: 900px) {
          .place-grid {
            grid-template-columns: 1fr;
          }
        }
        @media (max-width: 700px) {
          .place-sec {
            padding: 3rem 0;
          }
          .place-sec .wrap {
            padding: 0 1.3rem;
          }
        }
      `}</style>

      <div className="wrap place-grid">
        <div className="rv">
          <div className="place-eyebrow">
            <div className="place-eyebrow-dash" />
            <span className="place-eyebrow-text">Placements</span>
          </div>
          <h2 className="place-title">
            100% Placement <em>Assistance</em>
          </h2>
          <p className="place-sub">
            MoUs with government and private organisations nationwide open
            placement opportunities matched to your learning journey — plus
            unlimited 1:1 career counselling until you land the right role.
          </p>
          <a href="#admissions" className="place-btn">
            Talk to admissions
          </a>
        </div>

        <div className="place-stats rv d2">
          {placeStats.map((stat) => (
            <div className="place-stat" key={stat.value}>
              <b>{stat.value}</b>
              <span>{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Outcomes;